export const START_FETCH_ATTENDANCE = 'START_FETCH_ATTENDANCE'
export const SUCCESS_FETCH_ATTENDANCE = 'SUCCESS_FETCH_ATTENDANCE'
export const FAILED_FETCH_ATTENDANCE = 'FAILED_FETCH_ATTENDANCE'

export const RESET_SALARY = 'RESET_SALARY';
export const SET_SALARY = 'SET_SALARY';

import teacherAttendanceRecord from 'controllers/teacher/teacherAttendanceRecord'
import studentAttendanceRecord from 'controllers/student/studentAttendanceRecord'
import isEqual from 'lodash/isEqual';

export const DEFAULT_PAGINATION = {
  activePage: 0,
  itemsCountPerPage: 10,
  totalItemsCount: 0,
}

export function fetchAttendance(schoolId, state, attendanceInfo, callback){

  return function(dispatch) {
    dispatch({
      type: START_FETCH_ATTENDANCE,
      payload: {
        fetching: true,
      }
    })

    const controllerFunction = state == 'teacher' ? teacherAttendanceRecord : studentAttendanceRecord

    controllerFunction(schoolId, attendanceInfo)
    .then((result) => {

      dispatch({
        type: SUCCESS_FETCH_ATTENDANCE,
        payload: {...result, fetching: false}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      console.log(err)
      dispatch({
        type: FAILED_FETCH_ATTENDANCE,
        payload: err
      })
    })
  }
}

export const setTotalSalary = (salary) => {
  return {
    type: SET_SALARY,
    payload: salary
  };
};

export const resetTotalSalary = () => {
  return {
    type: RESET_SALARY,
  };
};

const initState = {
  list: [],
  pagination: DEFAULT_PAGINATION,
  totalSalary: 0,
}

export default function getAttendance(state = initState, action){
  switch(action.type){
    case START_FETCH_ATTENDANCE: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_ATTENDANCE: {
      let resetSalary = {}

      if (isEqual(state.list, action.payload.result_list) !== true || action.payload.result_list.length == 0) {
        resetSalary = {
          totalSalary: 0,
        }
      }

      return {
        ...state,
        list: action.payload.result_list,
        teacher_name: action.payload.teacher_name,
        unchecked_count: action.payload.total_unchecked_amount,
        unchecked_hour: action.payload.total_unchecked_duration,
        attended_count: action.payload.total_counted_amount,
        attended_hour: action.payload.total_counted_duration,
        unattended_count: action.payload.total_absent_amount,
        unattended_hour: action.payload.total_absent_duration,
        absent_count: action.payload.total_leave_amount,
        absent_hour: action.payload.total_leave_duration,
        truancy_count: action.payload.total_truancy_amount,
        truancy_hour: action.payload.total_truancy_duration,
        late_count: action.payload.total_late_amount,
        late_hour: action.payload.total_late_duration,
        normal_count: action.payload.total_normal_amount,
        normal_hour: action.payload.total_normal_duration,
        retroactive_count: action.payload.total_retroactive_amount,
        fetching: action.payload.fetching,
        result: action.payload.result,
        reason: action.payload.reason,
        ...resetSalary,

        pagination: {
          itemsCountPerPage: action.payload.amount_per_page || 10,
          activePage: action.payload.current_page_number || 1,
          totalItemsCount: action.payload.total_record_amount || 0,
        },

      }
    }
    case FAILED_FETCH_ATTENDANCE: {
      return state
    }

    case RESET_SALARY: {
      return { ...state, totalSalary: 0, }
    }

    case SET_SALARY: {
      return { ...state, totalSalary: action.payload }
    }

    default: return {...state}
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/ducks.js